import {IFilterFunction} from "angular";
import {ReportType} from "../../models/ReportType";

export const ReportTypeTranslationPipe = "tfOtReportTypeTranslation";

export function reportTypeTranslationPipe(): IFilterFunction {
    return (type: ReportType | null) => {
        if (type == null) {
            return null;
        } else {
            return "report." + type;
        }
    };
}
